import styled, { css } from 'styled-components';
import { colors } from '@10d/tend-ui-tokens/samolet';

const SVGDashedBorder = css`url("
  data:image/svg+xml,%3csvg
  width='100%25'
  height='100%25'
  xmlns='http://www.w3.org/2000/svg'%3e%3crect
  width='100%25'
  height='100%25'
  fill='none'
  rx='12'
  ry='12'
  stroke='%23BDC5DBFF' 
  stroke-width='1'
  stroke-dasharray='7%2c 7'
  stroke-dashoffset='0'
  stroke-linecap='round'/%3e%3c/svg%3e
")`;

const SVGActiveDashedBorder = css`url("
  data:image/svg+xml,%3csvg
  width='100%25'
  height='100%25'
  xmlns='http://www.w3.org/2000/svg'%3e%3crect
  width='100%25'
  height='100%25'
  fill='none'
  rx='12'
  ry='12'
  stroke='%23007BFBFF'
  stroke-width='1'
  stroke-dasharray='7%2c 7'
  stroke-dashoffset='0'
  stroke-linecap='round'/%3e%3c/svg%3e
")`;

const SVGDisabledDashedBorder = css`url("
  data:image/svg+xml,%3csvg
  width='100%25'
  height='100%25'
  xmlns='http://www.w3.org/2000/svg'%3e%3crect
  width='100%25'
  height='100%25'
  fill='none'
  rx='12'
  ry='12'
  stroke='%23BDC5DBFF' 
  stroke-width='1'
  stroke-dasharray='7%2c 7'
  stroke-dashoffset='0'
  stroke-linecap='round'/%3e%3c/svg%3e
")`;

export const Wrapper = styled.div<{ disabled?: boolean; error?: boolean }>`
  .ant-form-item {
    margin-bottom: 0;
  }

  .ant-upload.ant-upload-drag {
    background-color: transparent;
    background-image: ${SVGDashedBorder};
    border-radius: 12px;
    border: none;
    transition:
      background-color 150ms ease,
      background-image 150ms ease;

    ${({ disabled }) =>
      !disabled &&
      css`
        &:hover {
          background-color: #f0f5ff;
          background-image: ${SVGActiveDashedBorder};
        }
      `}

    ${({ disabled }) =>
      disabled &&
      css`
        background-color: #f7f9fe;

        &:hover {
          background-image: ${SVGDisabledDashedBorder};
        }

        path {
          fill: ${colors.gray400};
        }
      `}
        ${({ error }) =>
      error &&
      css`
        border: 1px red dashed;
        background-color: #f7f9fe;

        &:hover {
          background-image: ${SVGDisabledDashedBorder};
        }

        path {
          fill: ${colors.gray400};
        }
      `}
  }

  .ant-spin-container span:first-child .ant-upload-list.ant-upload-list-text,
  .ant-upload-list-item-actions a:first-child {
    display: none;
  }

  .ant-form-item-control-input-content {
    display: flex;
    flex-direction: column;
  }

  .ant-upload-list.ant-upload-list-text {
    margin-top: 16px;
  }

  .ant-upload-list-picture {
    margin-top: 16px;
  }

  .ant-upload-list-picture-card-container {
    margin: 8px 8px 8px 0;
  }

  .ant-upload-list.ant-upload-list-picture-card {
    display: flex;
    gap: 15px;

    &::before,
    &::after {
      display: none;
    }

    .ant-upload-list-picture-card-container {
      width: initial;
      height: initial;
      margin: 0;
    }
  }
`;

export const UploadArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  height: 62px;
  padding: 15px;
  margin-block-end: 20px;
  color: ${colors.gray900};
  font-weight: 600;

  background-color: transparent;
  background-image: ${SVGDashedBorder};
  border-radius: 12px;
  border: none;
  transition:
    background-color 150ms ease,
    background-image 150ms ease;

  &:hover {
    background-color: #f0f5ff;
    background-image: ${SVGActiveDashedBorder};
  }
`;

export const UploadIcon = styled.p`
  padding-bottom: 12px;
  display: flex;
  justify-content: center;
`;

export const UploadText = styled.p<{ disabled?: boolean }>`
  font-size: 14px;
  color: ${({ disabled }) => (disabled ? colors.gray400 : colors.gray900)};
  padding-bottom: 4px;
  font-weight: 600;
  line-height: 24px;

  b {
    color: ${({ disabled }) => (disabled ? colors.gray650 : colors.blue600)};
  }
`;

export const UploadHint = styled.p`
  font-size: 12px;
  line-height: 20px;
  color: ${colors.gray400};
`;
